export const ru = {
    'yandex': '«ЯНДЕКС»',
    'org': 'ООО {link}',
    'docs': 'Документация',
}
